<script>
export default {
  name: "custom-member-results",
  props: {
    setQuery: Function,
    query: Object
  },
  mounted() {
    this.setQuery(
        this.query
    );
  },
  render: h => null
};
</script>
